<template>
  <div class="mt-3">
    <v-alert v-if="error" type="error">
      {{ error }}
    </v-alert>
    <v-row v-if="loading && !tableMap">
      <v-col cols="12" sm="7" lg="8">
        <v-skeleton-loader type="image" height="170px" class="rounded-b-0" />
        <v-skeleton-loader type="image" height="170px" class="rounded-0" />
        <v-skeleton-loader type="image" height="170px" class="rounded-t-0" />
      </v-col>
      <v-col cols="12" sm="5" lg="4">
        <v-skeleton-loader type="card" height="250px" />
        <v-skeleton-loader type="card" height="250px" />
      </v-col>
    </v-row>

    <table-map-editor
      v-if="tableMap"
      :table-map="tableMap"
      :party="party"
      :loading="loading"
      @save="save"
    />
  </div>
</template>

<script>
import TableMapEditor from "./tableMap/TableMapEditor.vue";
import TABLE from "@/services/admin/party/table";

export default {
  components: { TableMapEditor },
  data: () => ({
    loading: false,
    error: false,
    tableMap: null,
  }),
  methods: {
    async save(mapData) {
      try {
        this.loading = true;

        const hasFileToUpload = mapData.backgroundUrl instanceof File;
        const data = {
          backgroundUrl: hasFileToUpload ? null : mapData.backgroundUrl,
          showInEventPage: mapData.showInEventPage,
          Groups: mapData.Groups.map((group) => ({
            id: Number.isInteger(group.id) ? null : group.id,
            name: group.name,
            color: group.color,
            capacity: group.capacity,
            options: group.options,
            Tables: group.Tables.map((table) => ({
              id: Number.isInteger(table.id) ? null : table.id,
              name: table.name,
              position: table.position,
              sellOnline: !!table.sellOnline,
              disabled: !!table.disabled,
              // options: table.options,
            })),
          })),
        };

        await TABLE.upsert(this.party.organizationId, this.party.id, data);

        if (hasFileToUpload) {
          await TABLE.upload(
            this.party.organizationId,
            this.party.id,
            mapData.backgroundUrl
          );
        }

        this.getTableMap();
      } catch (error) {
        this.error = error.message || "Erro ao salvar avaliação";
      } finally {
        this.loading = false;
      }
    },
    async getTableMap() {
      try {
        this.loading = true;
        const { tableMap } = await TABLE.get(
          this.party.organizationId,
          this.party.id
        );
        this.tableMap = tableMap || {
          backgroundUrl: null,
          Groups: [],
          showInEventPage: true,
        };
      } catch (error) {
        this.error = error.message || "Erro ao carregar avaliações";
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {},

  mounted() {
    this.getTableMap();
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style></style>
